import { render, staticRenderFns } from "./Covid.vue?vue&type=template&id=561940fd&scoped=true&"
import script from "./Covid.vue?vue&type=script&lang=js&"
export * from "./Covid.vue?vue&type=script&lang=js&"
import style0 from "./Covid.vue?vue&type=style&index=0&id=561940fd&scoped=true&lang=css&"
import style1 from "./Covid.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561940fd",
  null
  
)

export default component.exports